import React from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");
const customStyles = {
  content: {
    border: "none",
    right: "0",
    left: "0",
    margin: "auto",
    backgroundColor: "transparent",
    marginTop: "10vh",
    maxWidth: "349px"
  },
  overlay: {
    zIndex: 3,
    backgroundColor: " rgba(0, 0, 0, 0.7)"
  }
};

export const ConnectionLost = ({ isOnline }) => {
  return (
    <Modal isOpen={!isOnline} style={customStyles}>
      <div className="ch-fs--3 ch-text--center ch-bg--white ch-rounded ch-pa--6">
        <p className="ch-text--bold">Connection lost</p>
        <p className="ch-color--grey-6">
          Reconnect to the internet to continue.
        </p>
        <p className="ch-text--bold ch-mb--0">
          Retrying <span className="btn-loader retry-spinner" />
        </p>
      </div>
    </Modal>
  );
};
